import { render, staticRenderFns } from "./LocationDoll.vue?vue&type=template&id=522857e4&scoped=true"
import script from "./LocationDoll.vue?vue&type=script&lang=js"
export * from "./LocationDoll.vue?vue&type=script&lang=js"
import style0 from "./LocationDoll.vue?vue&type=style&index=0&id=522857e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522857e4",
  null
  
)

export default component.exports